import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthenticationState, UserProfile } from "./types";
import LocalStorage from "../../../util/storage";

const authData = LocalStorage.get("authData");

const initialState: AuthenticationState = {
	isAuthenticated: !!authData?.token,
	profile: authData?.user || null
};

export const slice = createSlice({
	name: "authentication",
	initialState,
	reducers: {
		loginSuccess: (
			state,
			action: PayloadAction<{ token: string; refreshToken: string; user: UserProfile }>
		) => {
			state.isAuthenticated = true;
			state.profile = action.payload.user;
			LocalStorage.set("authData", action.payload);
		},
		logout: (state) => {
			state.isAuthenticated = false;
			state.profile = null;
			LocalStorage.remove("authData");
		},
		updateProfile: (state, action: PayloadAction<UserProfile>) => {
			state.profile = action.payload;
		}
	}
});

export const { loginSuccess, logout, updateProfile } = slice.actions;

export default slice.reducer;
